import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';
import media from '~/client/shared/media';

const PublishDateBlock = styled.div`
  position: relative;
  width: calc(100% + ${rem(48)});
  margin-bottom: ${rem(32)};
  border-bottom: 0;
  padding-bottom: 0;
  ${media.phoneMedium} {
    width: auto;
    margin-bottom: ${rem(28)};
    border-bottom: ${rem(1)} solid ${({ theme }) => theme.color.beerus[100]};
    padding-bottom: ${rem(16)};
  }
  span {
    opacity: 0.5;
    font-size: ${rem(12)};
    position: relative;
    ${media.phoneMedium} {
      font-size: ${rem(14)};
    }
  }
`;

export default PublishDateBlock;
